import { render, staticRenderFns } from "./scene4.vue?vue&type=template&id=6cf150cf&"
import script from "./scene4.vue?vue&type=script&lang=js&"
export * from "./scene4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports